export default (state, payload) => {
	console.info('🦑 SET_ERROR');
	state.isError = payload !== null;
	state.error = payload === null ? null : payload;
};
